import React from "react";

// Hooks
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";

//Styles
import defaultClasses from "./sliderFullPage.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";

//Components
import Icon from "../Icon";

//Assets
import slide_1 from "../../assets/images/slider-registration/slide-1.jpg";
import slide_2 from "../../assets/images/slider-registration/slide-2.jpg";
import slide_3 from "../../assets/images/slider-registration/slide-3.jpg";
import slide_4 from "../../assets/images/slider-registration/slide-4.jpg";

//Utils
import { useIntl } from "react-intl";
var SliderFullPage = props => {
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    formatMessage
  } = useIntl();
  var {
    isMobile
  } = useWindowSize();
  var sliderNav = !isMobile ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "uk-position-center-left uk-position-small",
    href: "#",
    "data-uk-slideshow-item": "previous"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-arrow-left",
    color: "white",
    header: true,
    isCircled: true
  })), /*#__PURE__*/React.createElement("a", {
    className: "uk-position-center-right uk-position-small",
    href: "#",
    "data-uk-slideshow-item": "next"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-arrow-right",
    color: "white",
    header: true,
    isCircled: true
  }))) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.sliderFullPage, " uk-position-relative uk-visible-toggle uk-light slider-full-page"),
    tabIndex: "-1",
    "data-uk-slideshow": "animation: push"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "uk-slideshow-items",
    "data-uk-height-viewport": "min-height: 100vh"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    className: "uk-position-cover",
    "data-uk-slideshow-parallax": "scale: 1,1,1"
  }, /*#__PURE__*/React.createElement("img", {
    src: slide_1,
    alt: "",
    "data-uk-cover": true,
    style: {
      maxWidth: "unset",
      transform: "translateX(-20%"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-position-cover",
    "data-uk-slideshow-parallax": "opacity: 0,0,0.2; backgroundColor: #000,#000"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.content, " slider-full-content uk-position-bottom uk-position-small uk-text-center")
  }, /*#__PURE__*/React.createElement("div", {
    "data-uk-slideshow-parallax": "scale: 1,1,0.8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.caption, " uk-text-uppercase"),
    "data-uk-slideshow-parallax": "x: 400,0,0;"
  }, formatMessage({
    id: "registration.loyalty.info.title"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.title, " uk-text-uppercase"),
    "data-uk-slideshow-parallax": "x: 200,0,0"
  }, formatMessage({
    id: "registration.loyalty.info.title.part1"
  })), /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.subtitle),
    "data-uk-slideshow-parallax": "x: 400,0,0;"
  }, formatMessage({
    id: "registration.loyalty.info.subtitle.part1"
  }))))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    className: "uk-position-cover",
    "data-uk-slideshow-parallax": "scale: 1,1,1"
  }, /*#__PURE__*/React.createElement("img", {
    src: slide_2,
    alt: "",
    "data-uk-cover": true,
    style: {
      maxWidth: "unset",
      transform: "translateX(-20%"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-position-cover",
    "data-uk-slideshow-parallax": "opacity: 0,0,0.2; backgroundColor: #000,#000"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.content, " slider-full-content uk-position-bottom uk-position-small uk-text-center")
  }, /*#__PURE__*/React.createElement("div", {
    "data-uk-slideshow-parallax": "scale: 1,1,0.8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.caption, " uk-text-uppercase"),
    "data-uk-slideshow-parallax": "x: 400,0,0;"
  }, formatMessage({
    id: "registration.loyalty.info.title"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.title, " uk-text-uppercase"),
    "data-uk-slideshow-parallax": "x: 200,0,0"
  }, formatMessage({
    id: "registration.loyalty.info.title.part2"
  })), /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.subtitle),
    "data-uk-slideshow-parallax": "x: 400,0,0;"
  }, formatMessage({
    id: "registration.loyalty.info.subtitle.part2"
  }))))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    className: "uk-position-cover",
    "data-uk-slideshow-parallax": "scale: 1,1,1"
  }, /*#__PURE__*/React.createElement("img", {
    src: slide_3,
    alt: "",
    "data-uk-cover": true,
    style: {
      maxWidth: "unset",
      transform: "translateX(-20%"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-position-cover",
    "data-uk-slideshow-parallax": "opacity: 0,0,0.2; backgroundColor: #000,#000"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.content, " slider-full-content uk-position-bottom uk-position-small uk-text-center")
  }, /*#__PURE__*/React.createElement("div", {
    "data-uk-slideshow-parallax": "scale: 1,1,0.8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.caption, " uk-text-uppercase"),
    "data-uk-slideshow-parallax": "x: 400,0,0;"
  }, formatMessage({
    id: "registration.loyalty.info.title"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.title, " uk-text-uppercase"),
    "data-uk-slideshow-parallax": "x: 200,0,0"
  }, formatMessage({
    id: "registration.loyalty.info.title.part3"
  })), /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.subtitle),
    "data-uk-slideshow-parallax": "x: 400,0,0;"
  }, formatMessage({
    id: "registration.loyalty.info.subtitle.part3"
  }))))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    className: "uk-position-cover",
    "data-uk-slideshow-parallax": "scale: 1,1,1"
  }, /*#__PURE__*/React.createElement("img", {
    src: slide_4,
    alt: "",
    "data-uk-cover": true,
    style: {
      maxWidth: "unset",
      transform: "translateX(-20%"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-position-cover",
    "data-uk-slideshow-parallax": "opacity: 0,0,0.2; backgroundColor: #000,#000"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.content, " slider-full-content uk-position-bottom uk-position-small uk-text-center")
  }, /*#__PURE__*/React.createElement("div", {
    "data-uk-slideshow-parallax": "scale: 1,1,0.8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.caption, " uk-text-uppercase"),
    "data-uk-slideshow-parallax": "x: 400,0,0;"
  }, formatMessage({
    id: "registration.loyalty.info.title"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.title, " uk-text-uppercase"),
    "data-uk-slideshow-parallax": "x: 200,0,0"
  }, formatMessage({
    id: "registration.loyalty.info.title.part4"
  })), /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.subtitle),
    "data-uk-slideshow-parallax": "x: 400,0,0;"
  }, formatMessage({
    id: "registration.loyalty.info.subtitle.part4"
  })))))), /*#__PURE__*/React.createElement("ul", {
    className: "uk-position-center uk-slideshow-nav uk-dotnav uk-flex uk-flex-row uk-flex-center uk-flex-middle "
  }), sliderNav);
};
export default SliderFullPage;